<div class="opportunity-content">
  <!-- Contenedor interno para el resto del contenido -->
  <div class="main-content-inner">
    <!-- Cards de métricas financieras -->
    <div class="metrics-cards">
      <div class="metric-card">
        <div class="metric-label">Importe</div>
        <div class="metric-value ingreso" [nzTooltipTitle]="kpiCurrencyHint" nz-tooltip>{{ totalRevenue }}</div>
      </div>
      <div class="metric-card">
        <div class="metric-label">Gasto</div>
        <div class="metric-value gasto" [nzTooltipTitle]="kpiCurrencyHint" nz-tooltip>{{ totalExpenses }}</div>
      </div>
      <!-- CEC-565: el Margen Esperado es un calculo (Importe menos Gasto), asi que ya no se
           puede teclear. Lo que se escribia se guardaba y no se volvia a mostrar nunca. -->
      <div class="metric-card">
        <div class="metric-label">Margen Esperado</div>
        <div class="metric-value ingreso" [nzTooltipTitle]="kpiCurrencyHint" nz-tooltip>{{ expectedRevenue }}</div>
      </div>
    </div>

    <!-- Sección de probabilidad y datos relacionados -->
    <div class="probability-section">
      <!-- Probabilidad (Barra %) -->
      <div class="probability-item" [class.editing-top-field]="isFieldEditing('probability')"
        [class.editing-probability]="isFieldEditing('probability')">
        <span class="probability-label">Probabilidad</span>
        <div class="probability-content">
          <nz-progress *ngIf="!isFieldEditing('probability') && probabilityForInput !== null && probabilityForInput !== undefined"
            nzType="line"
            [nzPercent]="probabilityForInput"
            [nzShowInfo]="false"
            nzSize="default"
            [nzStrokeWidth]="8"
            [nzStrokeColor]="'#297A3A'"
            style="width: 200px; margin-right: 12px; cursor: pointer;"
            (click)="onFieldClick('probability', $event)">
          </nz-progress>
          <span *ngIf="!isFieldEditing('probability')" class="probability-value"
            (click)="onFieldClick('probability', $event)" style="cursor: pointer;">{{ probability }}</span>
          <span *ngIf="isFieldEditing('probability')" class="probability-edit-spacer" aria-hidden="true">
            <span class="probability-progress-spacer"></span>
            <span class="probability-value">{{ probability }}</span>
          </span>
          <input *ngIf="isFieldEditing('probability')" type="number" nzSize="large" nz-input
            [(ngModel)]="probabilityForInput" (blur)="onFieldBlur('probability', $event)" [attr.data-field]="'probability'"
            placeholder="0.00%" step="0.01" min="0" max="100" style="width: 120px;">
        </div>
      </div>

      <!-- Prioridad (Estrellas) -->
      <div class="probability-item">
        <span class="probability-label">Prioridad</span>
        <div *ngIf="!isFieldEditing('priority')" class="priority-stars" (click)="onFieldClick('priority', $event)"
          style="cursor: pointer;">
          <app-st-icon *ngFor="let star of priorityStars" [name]="'star'" [filled]="star"
            [style.color]="star ? '#F59E0B' : '#EBEBEB'" style="font-size: 16px;"></app-st-icon>
        </div>
        <div *ngIf="isFieldEditing('priority')" class="priority-stars top-edit-spacer" aria-hidden="true">
          <app-st-icon *ngFor="let star of priorityStars" [name]="'star'" [filled]="star"
            [style.color]="star ? '#F59E0B' : '#EBEBEB'" style="font-size: 16px;"></app-st-icon>
        </div>
        <nz-select *ngIf="isFieldEditing('priority')" nzSize="large" [ngModel]="opportunity?.priority"
          (nzOpenChange)="onEditOverlayOpenChange('priority', $event)"
          (ngModelChange)="onSelectChange('priority', $event)" [attr.data-field]="'priority'"
          nzPlaceHolder="Seleccione prioridad" nzAllowClear style="width: 150px;">
          <nz-option nzValue="Low" nzLabel="Baja"></nz-option>
          <nz-option nzValue="Medium" nzLabel="Media"></nz-option>
          <nz-option nzValue="High" nzLabel="Alta"></nz-option>
          <nz-option nzValue="VeryHigh" nzLabel="Muy Alta"></nz-option>
        </nz-select>
      </div>

      <!-- Tipo de Oportunidad -->
      <div class="probability-item opportunity-type-item" [class.editing-top-field]="isFieldEditing('opportunityType')">
        <span class="probability-label">Tipo de oportunidad</span>
        <span *ngIf="!isFieldEditing('opportunityType')" class="probability-value"
          (click)="onFieldClick('opportunityType', $event)" style="cursor: pointer;">{{ opportunityTypeDisplay }}</span>
        <span *ngIf="isFieldEditing('opportunityType')" class="probability-value top-edit-spacer" aria-hidden="true">
          {{ opportunityTypeDisplay }}
        </span>
        <nz-select *ngIf="isFieldEditing('opportunityType')" nzSize="large" [ngModel]="opportunityTypeForSelect"
          (nzOpenChange)="onEditOverlayOpenChange('opportunityType', $event)"
          (ngModelChange)="onOpportunityTypeChange($event)" [attr.data-field]="'opportunityType'"
          nzPlaceHolder="Seleccione tipo" [nzAllowClear]="false" style="width: 200px;">
          <nz-option nzValue="Proyecto" nzLabel="Proyecto"></nz-option>
          <nz-option nzValue="Servicio Puntual" nzLabel="Servicio Puntual"></nz-option>
        </nz-select>
      </div>

      <!-- Centro de Costo -->
      <div class="probability-item" [class.editing-top-field]="isFieldEditing('costCenterId')">
        <span class="probability-label">Centro de Costo</span>
        <span *ngIf="!isFieldEditing('costCenterId')" class="probability-value"
          (click)="onFieldClick('costCenterId', $event)" style="cursor: pointer;">{{ costCenterName }}</span>
        <span *ngIf="isFieldEditing('costCenterId')" class="probability-value top-edit-spacer" aria-hidden="true">
          {{ costCenterName }}
        </span>
        <nz-select *ngIf="isFieldEditing('costCenterId')" nzSize="large" [ngModel]="opportunity?.costCenterId"
          (nzOpenChange)="onEditOverlayOpenChange('costCenterId', $event)"
          (ngModelChange)="onSelectChange('costCenterId', $event)" [attr.data-field]="'costCenterId'"
          nzPlaceHolder="Seleccione centro de costo" [nzAllowClear]="false" nzShowSearch style="width: 200px;">
          <nz-option *ngFor="let costCenter of costCenters" [nzValue]="costCenter.id" [nzLabel]="costCenter.name">
          </nz-option>
        </nz-select>
      </div>

      <!-- Ingreso Estimado (Opcional) -->
      <!-- <div class="probability-item" *ngIf="expectedRevenue && expectedRevenue !== '$0,00'">
        <span class="probability-label">Ingreso Estimado</span>
        <span class="probability-value ingreso">{{ expectedRevenue }}</span>
      </div> -->
    </div>

    <!-- Sección de datos en dos columnas -->
    <div class="details-data-section">
      <!-- COLUMNA IZQUIERDA (Datos) -->
      <div class="details-column">
        <!-- Nombre -->
        <div class="detail-row">
          <span class="detail-label">Nombre:</span>
          <span *ngIf="!isFieldEditing('name')" class="detail-value" (click)="onFieldClick('name', $event)"
            style="cursor: pointer;">{{ opportunityName }}</span>
          <input *ngIf="isFieldEditing('name')" type="text" nzSize="large" nz-input [ngModel]="opportunityNameForInput"
            (blur)="onFieldBlur('name', $event)" [attr.data-field]="'name'" placeholder="Introduce nombre..."
            style="width: 200px;">
        </div>
        <!-- Empresa Intermediaria -->
        <div class="detail-row" [class.field-error]="hasFieldError('intermediaryCompanyId')">
          <span class="detail-label" [class.error-label]="hasFieldError('intermediaryCompanyId')">Empresa Intermediaria:</span>
          <span *ngIf="!isFieldEditing('intermediaryCompanyId')" class="detail-value"
            [class.error-value]="hasFieldError('intermediaryCompanyId')"
            (click)="onFieldClick('intermediaryCompanyId', $event)" style="cursor: pointer;">
            {{ intermediaryCompanyName }}
          </span>
          <nz-select *ngIf="isFieldEditing('intermediaryCompanyId')" nzSize="large"
            [ngModel]="opportunity?.intermediaryCompanyId"
            (nzOpenChange)="onEditOverlayOpenChange('intermediaryCompanyId', $event)"
            (ngModelChange)="onSelectChange('intermediaryCompanyId', $event)"
            [attr.data-field]="'intermediaryCompanyId'"
            [nzStatus]="hasFieldError('intermediaryCompanyId') ? 'error' : ''"
            nzPlaceHolder="Seleccione empresa intermediaria" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companiesList" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Empresa Cliente (Partner id de companiesList, no companyId) -->
        <div class="detail-row" [class.field-error]="hasFieldError('clientCompany')">
          <span class="detail-label" [class.error-label]="hasFieldError('clientCompany')">Empresa Cliente:</span>
          <span *ngIf="!isFieldEditing('clientCompany')" class="detail-value"
            [class.error-value]="hasFieldError('clientCompany')"
            (click)="onFieldClick('clientCompany', $event)" style="cursor: pointer;">
            <ng-container *ngIf="companiesListLoaded">{{ getOpportunityClientCompanyDisplay() }}</ng-container>
            <span *ngIf="!companiesListLoaded" style="opacity: 0; min-width: 1ch;">-</span>
          </span>
          <nz-select *ngIf="isFieldEditing('clientCompany')" nzSize="large"
            [ngModel]="getClientCompanyId()"
            (nzOpenChange)="onEditOverlayOpenChange('clientCompany', $event)"
            (ngModelChange)="onSelectChange('clientCompany', $event)"
            [attr.data-field]="'clientCompany'"
            [nzStatus]="hasFieldError('clientCompany') ? 'error' : ''"
            nzPlaceHolder="Seleccione empresa cliente" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companiesList" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Contacto -->
        <div class="detail-row" [class.field-error]="hasFieldError('partnerId')">
          <span class="detail-label">Contacto:</span>
          <div *ngIf="!isFieldEditing('partnerId')" class="detail-tag"
            [class.error-value]="hasFieldError('partnerId')"
            (click)="onFieldClick('partnerId', $event)" style="cursor: pointer;">
            <nz-avatar
              *ngIf="opportunity?.contactPartner"
              [nzSrc]="opportunity?.contactPartner?.avatar ? getSafeImageUrl(opportunity?.contactPartner?.avatar) : undefined"
              [nzText]="!opportunity?.contactPartner?.avatar ? getPartnerInitials(opportunity?.contactPartner) : undefined"
              [nzSize]="20"
              [style.backgroundColor]="!opportunity?.contactPartner?.avatar ? '#ffffff' : undefined"
              [style.color]="!opportunity?.contactPartner?.avatar ? '#000000' : undefined"
              [style.border]="!opportunity?.contactPartner?.avatar ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!opportunity?.contactPartner?.avatar ? '600' : undefined"
              style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ contactName }}</span>
          </div>
          <app-avatar-select *ngIf="isFieldEditing('partnerId')" [ngModel]="opportunity?.partnerId"
            (ngModelChange)="onSelectChange('partnerId', $event)" [options]="contactList.length > 0 ? contactList : globalValuesService.partnerlist || []"
            [createPartnerDrawerComponent]="ModifyPartnerDrawerComponent"
            [allowCreateNew]="true"
            [defaultParentId]="getClientCompanyId() || opportunity?.contactPartner?.parentId || null"
            [defaultIsEmployee]="true"
            [nzAllowClear]="false"
            [nzStatus]="hasFieldError('partnerId') ? 'error' : ''"
            [nzLoading]="contactLoading"
            [attr.data-field]="'partnerId'" placeholder="Seleccione contacto"
            (partnerCreated)="onPartnerCreated($event)"
            style="width: 200px;">
          </app-avatar-select>
        </div>
        <!-- Correo electrónico -->
        <div class="detail-row">
          <span class="detail-label">Email:</span>
          <span *ngIf="!isFieldEditing('email')" class="detail-value" (click)="onFieldClick('email', $event)"
            style="cursor: pointer;">{{ opportunity?.email || opportunity?.contactPartner?.email || '-' }}</span>
          <input *ngIf="isFieldEditing('email')" type="email" nzSize="large" nz-input
            [ngModel]="opportunity?.email || ''" (blur)="onFieldBlur('email', $event)" [attr.data-field]="'email'"
            placeholder="Introduce email..." style="width: 200px;">
        </div>
        <!-- Teléfono -->
        <div class="detail-row">
          <span class="detail-label">Teléfono:</span>
          <span *ngIf="!isFieldEditing('phone')" class="detail-value" (click)="onFieldClick('phone', $event)"
            style="cursor: pointer;">{{ opportunity?.phone || opportunity?.contactPartner?.phone || '-' }}</span>
          <input *ngIf="isFieldEditing('phone')" type="tel" nzSize="large" nz-input [ngModel]="opportunity?.phone || ''"
            (blur)="onFieldBlur('phone', $event)" [attr.data-field]="'phone'" placeholder="Introduce teléfono..."
            style="width: 200px;">
        </div>
        <!-- ID -->
<!--        <div class="detail-row">-->
<!--          <span class="detail-label">ID:</span>-->
<!--          <span class="detail-value">{{ (opportunity?.id || opportunity?.originalId || '-').toString() }}</span>-->
<!--        </div>-->
      </div>

      <!-- COLUMNA DERECHA (Admin) -->
      <div class="details-column">
        <!-- Fecha de Creación -->
        <div class="detail-row">
          <span class="detail-label">Fecha de Creación:</span>
          <span class="detail-value">{{ formatDate(opportunity?.createdOn ?? opportunity?.created_at ?? null) }}</span>
        </div>

        <!-- Cierre previsto -->
        <div class="detail-row">
          <span class="detail-label">Cierre Prev.:</span>
          <span *ngIf="!isFieldEditing('expectedClosingDate')" class="detail-value"
            (click)="onFieldClick('expectedClosingDate', $event)" style="cursor: pointer;">{{
            formattedExpectedClosingDate }}</span>
          <nz-date-picker *ngIf="isFieldEditing('expectedClosingDate')" class="opportunity-inline-date-picker"
            [nzClassName]="'opportunity-inline-date-picker'" nzSize="large" [ngModel]="dateForPicker"
            (nzOpenChange)="onEditOverlayOpenChange('expectedClosingDate', $event)"
            (ngModelChange)="onDateChange('expectedClosingDate', $event)" [attr.data-field]="'expectedClosingDate'"
            [nzDisabledDate]="disabledPastDate" nzPlaceHolder="Seleccione fecha" style="width: 200px;">
          </nz-date-picker>
        </div>
        <!-- Moneda -->
        <div class="detail-row">
          <span class="detail-label">Moneda:</span>
          <span *ngIf="!isFieldEditing('currencyId')" class="detail-value" (click)="onFieldClick('currencyId', $event)"
            style="cursor: pointer;">{{ getCurrencyName(opportunity?.currencyId) }}</span>
          <nz-select *ngIf="isFieldEditing('currencyId')" nzSize="large" [ngModel]="opportunity?.currencyId"
            (nzOpenChange)="onEditOverlayOpenChange('currencyId', $event)"
            (ngModelChange)="onSelectChange('currencyId', $event)" [attr.data-field]="'currencyId'"
            nzPlaceHolder="Seleccione moneda" [nzAllowClear]="false" nzShowSearch style="width: 200px;">
            <nz-option *ngFor="let currency of currencies" [nzValue]="currency.id"
              [nzLabel]="currency.isoCode || currency.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Equipo -->
        <div class="detail-row">
          <span class="detail-label">Equipo:</span>
          <span *ngIf="!isFieldEditing('teamId')" class="detail-value" (click)="onFieldClick('teamId', $event)"
            style="cursor: pointer;">{{ salesTeamName }}</span>
          <nz-select *ngIf="isFieldEditing('teamId')" nzSize="large" [ngModel]="opportunity?.teamId"
            (nzOpenChange)="onEditOverlayOpenChange('teamId', $event)"
            (ngModelChange)="onSelectChange('teamId', $event)" [attr.data-field]="'teamId'"
            nzPlaceHolder="Seleccione equipo de ventas" [nzAllowClear]="false" nzShowSearch style="width: 200px;">
            <nz-option *ngFor="let salesTeam of globalValuesService.salesTeams$.value || []" [nzValue]="salesTeam.id"
              [nzLabel]="salesTeam.name">
            </nz-option>
          </nz-select>
        </div>
        <!-- Comercial -->
        <div class="detail-row">
          <span class="detail-label">Comercial:</span>
          <!-- Si hay equipo seleccionado pero no hay comerciales, mostrar mensaje directamente sin permitir click -->
          <div *ngIf="opportunity?.teamId && filteredUsersForTeam.length === 0 && !isFieldEditing('userId')"
            style="width: 200px; padding: 8px; color: #999; font-size: 14px;">
            No hay comerciales disponibles para este equipo
          </div>
          <!-- Si hay comerciales disponibles o no hay equipo, mostrar campo editable -->
          <div *ngIf="(!opportunity?.teamId || filteredUsersForTeam.length > 0) && !isFieldEditing('userId')"
            class="detail-tag"
            [style.cursor]="editPermissions ? 'pointer' : 'default'"
            (click)="editPermissions && onFieldClick('userId', $event)">
            <nz-avatar
              *ngIf="opportunity?.comercialUser"
              [nzSrc]="opportunity?.comercialUser?.avatar ? getSafeImageUrl(opportunity?.comercialUser?.avatar) : undefined"
              [nzText]="!opportunity?.comercialUser?.avatar ? getUserInitialsFromUser(opportunity?.comercialUser) : undefined"
              [nzSize]="20"
              [style.backgroundColor]="!opportunity?.comercialUser?.avatar ? '#ffffff' : undefined"
              [style.color]="!opportunity?.comercialUser?.avatar ? '#000000' : undefined"
              [style.border]="!opportunity?.comercialUser?.avatar ? '1px solid #d9d9d9' : undefined"
              [style.fontWeight]="!opportunity?.comercialUser?.avatar ? '600' : undefined"
              style="margin-right: 8px;">
            </nz-avatar>
            <span>{{ commercialName }}</span>
          </div>
          <nz-select *ngIf="isFieldEditing('userId') && filteredUsersForTeam.length > 0" nzSize="large" [ngModel]="opportunity?.userId"
            (nzOpenChange)="onEditOverlayOpenChange('userId', $event)"
            (ngModelChange)="onSelectChange('userId', $event)" [attr.data-field]="'userId'"
            nzPlaceHolder="Seleccione comercial" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let user of filteredUsersForTeam" [nzValue]="user.id"
              [nzLabel]="user.partner ? ((user.partner.name || '') + ' ' + (user.partner.surName || '')) : ''">
            </nz-option>
          </nz-select>
          <div *ngIf="isFieldEditing('userId') && filteredUsersForTeam.length === 0"
            style="width: 200px; padding: 8px; color: #999; font-size: 14px;">
            No hay comerciales disponibles para este equipo
          </div>
        </div>

        <!-- Compañía -->
        <div class="detail-row">
          <span class="detail-label">Compañía:</span>
          <span *ngIf="!isFieldEditing('companyId')" class="detail-value" (click)="onFieldClick('companyId', $event)"
            style="cursor: pointer;">{{ companyName }}</span>
          <nz-select *ngIf="isFieldEditing('companyId')" nzSize="large" [ngModel]="opportunity?.companyId"
            (nzOpenChange)="onEditOverlayOpenChange('companyId', $event)"
            (ngModelChange)="onSelectChange('companyId', $event)" [attr.data-field]="'companyId'"
            nzPlaceHolder="Seleccione compañía" nzShowSearch nzAllowClear style="width: 200px;">
            <nz-option *ngFor="let company of companies" [nzValue]="company.id" [nzLabel]="company.name">
            </nz-option>
          </nz-select>
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <nz-tabset *ngIf="afterViewInit" [(nzSelectedIndex)]="activeTabIndex" style="overflow-y: auto; overflow-x: hidden; min-height: 500px;">
      <nz-tab [nzTitle]="presupuestoTemplate">
        <ng-template #presupuestoTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'paid'"></app-st-icon>
          Presupuestos
        </ng-template>
        <div class="tab-content">
          <div *ngIf="!budgets || budgets.length === 0" class="empty-container">
            <p class="text-label-14 text-dark">No hay presupuestos asociados</p>
          </div>
          <div *ngIf="budgets && budgets.length > 0" class="budgets-list">
            <div *ngFor="let budget of budgets" class="budget-item">
              <div class="budget-row">
                <div class="budget-column">
                  <div class="budget-field">
                    <span class="budget-label">Nombre:</span>
                    <span class="budget-value clickable" (click)="onBudgetClick(budget); $event.stopPropagation()">{{
                      getBudgetNavigationReference(budget) }}</span>
                  </div>
                  <div class="budget-field">
                    <span class="budget-label">Contacto:</span>
                    <div *ngIf="budget.partnerId" class="budget-tag">
                      <nz-avatar [nzSrc]="getSafeImageUrl(getPartnerAvatar(budget.partnerId))" [nzSize]="20"
                        style="margin-right: 8px;">
                      </nz-avatar>
                      <span>{{ getPartnerName(budget.partnerId) }}</span>
                    </div>
                    <span *ngIf="!budget.partnerId" class="budget-value">-</span>
                  </div>
                  <div class="budget-field">
                    <span class="budget-label">Cliente:</span>
                    <div *ngIf="getBudgetCustomerCompanyName(budget) !== '-'" class="budget-tag">
                      <nz-avatar
                        *ngIf="getBudgetCustomerCompanyAvatar(budget) || getBudgetCustomerCompanyInitials(budget)"
                        [nzSrc]="getBudgetCustomerCompanyAvatar(budget) ? getSafeImageUrl(getBudgetCustomerCompanyAvatar(budget)) : undefined"
                        [nzText]="!getBudgetCustomerCompanyAvatar(budget) ? getBudgetCustomerCompanyInitials(budget) : undefined"
                        [nzSize]="20"
                        [style.backgroundColor]="!getBudgetCustomerCompanyAvatar(budget) ? '#ffffff' : undefined"
                        [style.color]="!getBudgetCustomerCompanyAvatar(budget) ? '#000000' : undefined"
                        [style.border]="!getBudgetCustomerCompanyAvatar(budget) ? '1px solid #d9d9d9' : undefined"
                        [style.fontWeight]="!getBudgetCustomerCompanyAvatar(budget) ? '600' : undefined"
                        style="margin-right: 8px;">
                      </nz-avatar>
                      <span>{{ getBudgetCustomerCompanyName(budget) }}</span>
                    </div>
                    <span *ngIf="getBudgetCustomerCompanyName(budget) === '-'" class="budget-value">-</span>
                  </div>
                </div>
                <div class="budget-column">
                  <div class="budget-field">
                    <span class="budget-label">Estado:</span>
                    <span class="budget-status-badge" [class]="getBudgetStageClass(budget)">{{ getBudgetStageName(budget) }}</span>
                  </div>
                  <div class="budget-field">
                    <span class="budget-label">Vencimiento:</span>
                    <span class="budget-value">{{ formatDate(budget.expirationDate) }}</span>
                  </div>
                  <div class="budget-field">
                    <span class="budget-label">Fecha del presupuesto:</span>
                    <span class="budget-value">{{ formatDate(budget.budgetDate) }}</span>
                  </div>
                </div>
                <button
                  *ngIf="editPermissions && !budget.dateConfirm"
                  nz-button
                  nzType="text"
                  nzShape="circle"
                  nzDanger
                  class="delete-budget-btn"
                  (click)="onDeleteBudget(budget, $event)">
                  <app-st-icon [bold]="true" name="delete"></app-st-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="descripcionTemplate">
        <ng-template #descripcionTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'menu_book'"></app-st-icon>
          Descripción
        </ng-template>
        <div class="tab-content">
          <div *ngIf="!isFieldEditing('description')" class="text-label-14 text-dark description-view"
            [class.description-edit-mode]="isFieldEditing('description')"
            style="hyphens: auto; padding: 12px 15px;"
            (click)="onFieldClick('description', $event)">
            <span *ngIf="!opportunity?.description || opportunity?.description === '<p><br></p>' || opportunity?.description === '<p></p>' || opportunity?.description === '<p><br/></p>'" >-</span>
            <span *ngIf="opportunity?.description && opportunity?.description !== '<p><br></p>' && opportunity?.description !== '<p></p>' && opportunity?.description !== '<p><br/></p>'" class="rich-text-content" [innerHTML]="sanitizeHtml(opportunity?.description)"></span>
          </div>
          <quill-editor *ngIf="isFieldEditing('description')"
            #quillEditor
            [ngModel]="opportunity?.description || ''"
            (ngModelChange)="!isInsertingImage && onQuillContentChanged('description', $event)"
            (onBlur)="onQuillBlur('description')"
            (onEditorCreated)="onQuillEditorCreated($event)"
            [modules]="quillConfig"
            placeholder="Introduce descripción..."
            [styles]="{height: '300px'}">
          </quill-editor>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="documentosTemplate">
        <ng-template #documentosTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'description'"></app-st-icon>
          Documentos
        </ng-template>
        <div class="tab-content">
          <app-doc-section [entityType]="'Lead'" [entityId]="opportunity?.id || opportunity?.originalId"
            [documents]="documents || []">
          </app-doc-section>
        </div>
      </nz-tab>
      <nz-tab [nzTitle]="proyectosTemplate">
        <ng-template #proyectosTemplate>
          <app-st-icon style="margin-right: 5px" [name]="'folder'"></app-st-icon>
          Proyectos
        </ng-template>
        <div class="tab-content">
          <div *ngIf="!opportunity?.projects || opportunity.projects.length === 0" class="empty-container">
            <p class="text-label-14 text-dark">No hay proyectos asociados</p>
          </div>
          <nz-collapse *ngIf="opportunity?.projects && opportunity.projects.length > 0" [nzBordered]="false" class="projects-accordion">
            <nz-collapse-panel *ngFor="let project of opportunity.projects; let i = index" [nzHeader]="projectHeaderTmpl" [nzActive]="false" [nzShowArrow]="false">
              <ng-template #projectHeaderTmpl>
                <div class="project-accordion-header">
                  <app-st-icon [name]="'folder'" class="project-header-icon"></app-st-icon>
                  <span class="project-name">{{ getProjectDisplayName(project) }}</span>
                  <div class="project-header-actions" (click)="$event.stopPropagation()">
                    <a *ngIf="getProjectId(project)" class="project-go-link" nz-tooltip nzTooltipTitle="Ir al proyecto" (click)="onProjectLinkClick($event, project)">
                      <app-st-icon name="open_in_new" [bold]="true" style="font-size: 16px; color: #1890ff;"></app-st-icon>
                    </a>
                    <button *ngIf="editPermissions && getProjectId(project)" nz-button nzType="text" nzShape="circle" nzDanger nz-tooltip nzTooltipTitle="Desvincular" class="project-delete-btn" (click)="onDeleteProject(project, $event)">
                      <app-st-icon name="delete" [bold]="true" style="font-size: 16px;"></app-st-icon>
                    </button>
                  </div>
                </div>
              </ng-template>
              <div class="project-accordion-body">
                <div class="project-detail-columns">
                  <div class="project-detail-col">
                    <div class="project-detail-row">
                      <span class="project-detail-label">Tareas:</span>
                      <span class="project-detail-value project-detail-with-progress">
                        <nz-progress nzType="circle" [nzPercent]="getProjectTasksPercent(project)" [nzWidth]="20" [nzShowInfo]="false" nzStrokeColor="#1890ff" class="project-detail-progress"></nz-progress>
                        {{ getProjectTasksSummary(project) }}
                      </span>
                    </div>
                    <div class="project-detail-row">
                      <span class="project-detail-label">Subtareas:</span>
                      <span class="project-detail-value project-detail-with-progress">
                        <nz-progress nzType="circle" [nzPercent]="getProjectSubtasksPercent(project)" [nzWidth]="20" [nzShowInfo]="false" nzStrokeColor="#52c41a" class="project-detail-progress"></nz-progress>
                        {{ getProjectSubtasksSummary(project) }}
                      </span>
                    </div>
                    <div class="project-detail-row">
                      <span class="project-detail-label">Etapa de proyecto:</span>
                      <span *ngIf="getProjectStageDisplay(project) as stageData" class="project-detail-value">
                        <span class="st-badget project-status-badge" [ngClass]="stageData.class">
                          <app-st-icon [bold]="true" [name]="stageData.icon"></app-st-icon>
                          <label>{{ stageData.name }}</label>
                        </span>
                      </span>
                      <span *ngIf="!getProjectStageDisplay(project)" class="project-detail-value">—</span>
                    </div>
                  </div>
                  <div class="project-detail-col">
                    <div class="project-detail-row">
                      <span class="project-detail-label">Resumen del proyecto:</span>
                      <span class="project-detail-value project-summary-text">{{ getProjectSummaryText(project) }}</span>
                    </div>
                    <div class="project-detail-row">
                      <span class="project-detail-label">Última actualización:</span>
                      <span class="project-detail-value">{{ getProjectLastUpdateRelative(project) }}</span>
                    </div>
                    <div class="project-detail-row">
                      <span class="project-detail-label">Estado del proyecto:</span>
                      <span *ngIf="getProjectStateDisplay(project) as stateData" class="project-detail-value">
                        <span class="st-badget project-status-badge project-state-badge-body" [style.background-color]="stateData.color">
                          <app-st-icon [bold]="true" [name]="stateData.icon"></app-st-icon>
                          <label>{{ stateData.name }}</label>
                        </span>
                      </span>
                      <span *ngIf="!getProjectStateDisplay(project)" class="project-detail-value">—</span>
                    </div>
                  </div>
                </div>
              </div>
            </nz-collapse-panel>
          </nz-collapse>
        </div>
      </nz-tab>
    </nz-tabset>
  </div>
</div>

<app-confirmation-modal
  #deleteBudgetConfirmationModal
  (confirmed)="onDeleteBudgetConfirmed($event)">
</app-confirmation-modal>

<app-confirmation-modal
  #deleteProjectConfirmationModal
  (confirmed)="onDeleteProjectConfirmed($event)">
</app-confirmation-modal>

<!-- Template para el modal de link (contenido + footer en uno para tener contexto del componente) -->
<ng-template #linkModalTemplate let-component="$implicit.component">
  <div class="link-modal-content">
    <label class="link-modal-label">URL del enlace:</label>
    <input
      #linkInput
      type="text"
      [ngModel]="component?.linkModalUrl"
      (ngModelChange)="component && (component.linkModalUrl = $event)"
      placeholder="https://ejemplo.com"
      nz-input
      class="link-modal-input"
      (keydown.enter)="component?.onLinkModalEnter()"
    />
  </div>
  <div class="link-modal-footer">
    <button nz-button nzType="text" nzDanger nzShape="round" nzSize="large" (click)="component?.removeLinkFromSelection()">
      Quitar enlace
    </button>
    <span class="link-modal-footer-spacer"></span>
    <button nz-button nzType="text" nzShape="round" nzSize="large" (click)="component?.closeLinkModal()">Cancelar</button>
    <button nz-button nzType="primary" nzShape="round" nzSize="large" (click)="component?.onLinkModalConfirm()">Aceptar</button>
  </div>
</ng-template>
